import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class Services extends Component {
  state = {
    toggle: "",
  };

  toggle = (data) => (e) => {
    this.setState({
      toggle: data,
    });
  };
  render() {
    const { match } = this.props;
    return (
      <Fragment>
        <div className="page-title-banner _employers">
          <div className="title">
            <h1>Services</h1>
          </div>
        </div>

        <div className="page-content container-fluid _employers pt-5 pb-5">
          <div className="inside-page-section container pt-5 pb-5">
            <div className="row">
              <div className="box right col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="text">
                  <p>
                    Since 1972, IPAMS (License No. POEA-247-LB-120911-PA) has
                    built an enviable reputation of providing our clients with
                    the most qualified personnel for our clients' manpower
                    needs. A consistent recipient of numerous awards from
                    various government organizations, we uphold the highest
                    standards of excellence in our recruitment processes.
                  </p>

                  <h4>Overseas Recruitment and Career Placement</h4>
                  <p>
                    IPAMS is duly licensed by the Philippine Overseas Employment
                    Administration (POEA) under the Department of Labor and
                    Employment (DOLE) of the Philippines.
                  </p>
                  <p>
                    IPAMS has been recruiting all types and categories of
                    Filipino professionals and skilled workers for our overseas
                    principals in the following careers:
                  </p>
                  <ul className="indent">
                    <li>
                      {" "}
                      <p>- Administration and Accountancy</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Aviation and Travel</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Engineering and Technical Work</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Executive, Management and Supervisory Levels</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Healthcare</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Hospitality</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Oil and petrochemical Industries</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Professional and Non-Professional Positions</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Skilled / Specialized Work</p>{" "}
                    </li>
                    <li>
                      {" "}
                      <p>- Other Industries</p>{" "}
                    </li>
                  </ul>

                  <p>
                    Around 62,000 Filipinos (for both single and family status
                    positions) have been deployed internationally.
                  </p>
                  <p>
                    {" "}
                    From the first step of sourcing qualified candidates from
                    our manpower pool, advertising job requirements,
                    pre-screening and short-listing candidates by our
                    experienced and qualified personnel, to the final interview
                    conducted by IPAMS and our principals -- IPAMS ensures a
                    competitive edge in efficiency and quality of operations.
                  </p>
                  <p>
                    Once selected, candidates are ensured to be medically fit
                    through IPAMS' referrals to accredited medical clinics
                    approved by the Philippine Government. POEA, National Bureau
                    of Investigation (NBI), and Embassy clearances are also
                    secured by IPAMS.
                  </p>
                  <p>
                    A Pre-Departure Orientation Seminar (PDOS) is conducted by
                    certified PDOS Trainers in IPAMS to ensure the preparedness
                    of hired candidates. Final arrangements, flight bookings and
                    departure from the airport are also taken care of by IPAMS.
                  </p>

                  <h4>Employee Relations and Re-Contracting Services</h4>
                  <p>
                    Employee Relations and re-contracting services are also
                    provided to ensure long-term employment of deployed workers.
                    This includes: family assistance, particularly during
                    emergency situations, allotment problems of the
                    beneficiaries, return travel processing and scheduling, and
                    other related services.
                  </p>

                  <h4>U.S. and Canadian Recruitment of Professionals</h4>
                  <p>
                    IPAMS initially ventured into U.S. recruitment in 1986 after
                    numerous years of employment activities for the Middle East,
                    GCC States, Africa, and ASEAN countries.
                  </p>
                  <p>
                    To date, IPAMS has become one of the leading institutions in
                    the placement of Filipino professionals in the fields of
                    Healthcare and Information Technology in the United States
                    and Canada. IPAMS has also been active in the recruitment of
                    professionals in various industries in other regions
                    worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, routeParams) => {
  const { loadingTypes } = state.loading;

  return {
    isLoading: loadingTypes.length > 0,
  };
};

export default withRouter(connect(mapStateToProps)(Services));
